import React, { createContext, useContext, useState, useMemo } from "react";
import { Step } from "react-joyride";
import { buildTourSteps } from "./joyRideSteps/buildTourSteps";

interface TourContextType {
    steps: Step[];
    stepIndex: number;
    run: boolean;
    startTour: (steps?: Step[], startIndex?: number) => void;
    setStepIndex: (index: number) => void;
    setRun: (run: boolean) => void;
    setSteps: (steps: Step[]) => void;
    shouldOpenModal: boolean;
    setShouldOpenModal: (value: boolean) => void;
    shouldCloseModal: boolean;
    setShouldCloseModal: (value: boolean) => void;
}

const TourContext = createContext<TourContextType | null>(null);

export const TourProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [steps, setSteps] = useState<Step[]>([]);
    const [stepIndex, setStepIndex] = useState(0);
    const [run, setRun] = useState(false);
    const [shouldOpenModal, setShouldOpenModal] = useState(false);
    const [shouldCloseModal, setShouldCloseModal] = useState(false);

    const startTour = (guideSteps?: Step[], startIndex = 0) => {
        if (guideSteps)
            setSteps(() => buildTourSteps(guideSteps));
        setStepIndex(startIndex);
        setRun(true);
    };

    return (
        <TourContext.Provider value={{
            steps, stepIndex, run, startTour, setStepIndex, setRun,setSteps, shouldOpenModal,
            setShouldOpenModal, shouldCloseModal, setShouldCloseModal
        }}>
            {children}
        </TourContext.Provider>
    );
};

export const useTour = () => {
    const ctx = useContext(TourContext);
    if (!ctx) throw new Error("useTour must be used inside TourProvider");
    return ctx;
};
